.mentionText {
  width: 90%;
}
